import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseOjetaSearch } from '@/modules/ojeta-vozidla/helpers';

/**
 * List-filter mirror + the assign-customer hand-offs (same trick as
 * vozidlo-detail.tsx):
 * - `?priradit=1` — OjetoForm lands here after a save whose state requires a
 *   customer (`requires_customer`);
 *   the detail auto-opens the assign modal.
 * - `?id_zakaznika=N` — the "Nový zákazník" round-trip; ZakaznikForm appends
 *   the fresh id to `return_url` and the detail finishes the assignment.
 */
function parseDetailSearch(input: Record<string, unknown>) {
  const out: ReturnType<typeof parseOjetaSearch> & {
    priradit?: number;
    id_zakaznika?: number;
  } = parseOjetaSearch(input);
  if (input.priradit === 1 || input.priradit === '1') out.priradit = 1;
  const z = input.id_zakaznika;
  if (typeof z === 'number' && Number.isFinite(z) && z > 0) out.id_zakaznika = z;
  if (typeof z === 'string' && /^\d+$/.test(z)) out.id_zakaznika = Number(z);
  return out;
}

const OjetoDetail = lazy(() =>
  import('@/modules/ojeta-vozidla/OjetoDetail').then((m) => ({ default: m.OjetoDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/$id',
  component: () => (
    <Suspense fallback={null}>
      <OjetoDetail />
    </Suspense>
  ),
  validateSearch: parseDetailSearch,
});
